import {
  FETCH_UNITS_SUCCESS,
} from './actions';
import { Map } from 'immutable';
import Unit from './model';

export default function sessions(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_UNITS_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  const units = action.payload.reduce((unitResults, unit) =>
      unitResults.set(`${unit.id}`, Unit.create(unit)), new Map());
  return state.set(action.groupId, units);
}



// WEBPACK FOOTER //
// ./data/Units/reducer.js